import { Badge, CloudDownload, HelpOutline } from '@mui/icons-material'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import { CommonTextBox, MultilineTextBox } from '../../components/TextBox'
import { toggleUploadDialog } from '../../store/slice/dialogSlice'
import UploadDialog from '../../components/Dialog/UploadDialog'
import { validateAttachments } from '../../components/Dialog/attachmentValidation'
import { useDispatch } from 'react-redux'
import { usePostSupportMutation } from '../../store/api/userApi'
import { showErrorToast, showSuccessToast, showWarningToast } from '../../constToast/constToast'

const Help = () => {
  const dispatch = useDispatch();
  const [attachments, setAttachments] = useState([])
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState('')
  const [title, setTitle] = useState('')

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setComment('')
    setTitle('')
    setAttachments([])
  }


  const [postSupport] = usePostSupportMutation();

  const handleSend = async () => {
    if (!title || !comment) {
      showWarningToast("Title ve Comment alanları boş bırakılamaz!"); // Hata mesajını göster
      return; // İşlemi durdur
    }

    // fileLink-i olmayan attachment save-e getmemelidir
    if (!validateAttachments(attachments)) {
      return;
    }

    try {
      const response = await postSupport({
        subject: title,
        description: comment,
        attachments: attachments?.filter((attachment) => attachment.type === 0),
      }).unwrap();
      showSuccessToast('Successfully')
      setOpen(false)
      setComment('')
      setTitle('')
      setAttachments([])
    } catch (error) {
      showErrorToast('Error', error)
    }
  };

  return (
    <div>
      <IconButton color="inherit" onClick={handleClick}>
        <HelpOutline />
      </IconButton>

      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Support</DialogTitle>
        <Divider />
        <DialogContent>
          <Box mb={2}><CommonTextBox label='Title' value={title} setValue={setTitle}></CommonTextBox></Box>
          <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
        </DialogContent>
        <DialogActions>
          <Button sx={{ marginLeft: 2 }} onClick={() => dispatch(toggleUploadDialog())} variant='contained' endIcon={<CloudDownload />}>
            Attachments
          </Button>
          <Button variant="contained" onClick={handleSend} >
            Send
          </Button>
          <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>


      <UploadDialog
        module={'SUPPORT'}
        value={attachments || []}
        setValue={setAttachments}
        initialData={attachments || []}
      />
    </div>
  )
}

export default Help